import { Injectable } from '@angular/core';

/**
 * Service for accessing the global window object.
 * This is a common pattern for being able to mock the window object in tests.
 */
@Injectable({
  providedIn: 'root'
})
export class WindowService {
  get nativeWindow(): Window {
    return window;
  }
}
